import { z } from 'zod';

/** Body for recomputing per-transaction category suggestions from history. */
export const suggestCategoriesInputSchema = z.object({
  bankAccountId: z.string().uuid().optional(),
});
export type SuggestCategoriesInput = z.infer<typeof suggestCategoriesInputSchema>;

export interface SuggestCategoriesResult {
  /** Unmatched transactions that received a history-based suggestion. */
  updated: number;
  /** Of the remainder, how many the AI fallback categorized. */
  aiUpdated: number;
}

/**
 * A rule the system proposes based on how similar past transactions were
 * categorized. The user reviews it and saves it in one click; once saved it
 * auto-applies on future syncs like any other bank rule.
 */
export interface RuleSuggestion {
  /** Normalized merchant key the pattern is built from (e.g. "comcast"). */
  key: string;
  /** Suggested matchValue for the rule (the key, used with contains). */
  matchValue: string;
  /** A few example descriptions that produced this pattern. */
  sampleDescriptions: string[];
  targetAccountId: string;
  accountCode: string;
  accountName: string;
  /** Optional dominant contact seen on past matches of this pattern. */
  suggestedContactId: string | null;
  contactName: string | null;
  /** How many past matched transactions support this pattern. */
  count: number;
  /** Share of those that went to the suggested account (0..1). */
  confidence: number;
}

export interface RuleSuggestionsResponse {
  suggestions: RuleSuggestion[];
}
